module.exports = __webpack_public_path__ + "static/img/index_banner.f5cf68b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner.png
// module id = HUpC
// module chunks = 1